import { noAuthAxios, authAxios } from "./api"

export const QUERY_KEY = "schedule"
export const BASE_URL = "app/schedule/"


export const listSchedule = () => noAuthAxios.get(BASE_URL + "?page_size=150")
export const addSchedule = (data:any) => authAxios.post(BASE_URL,data)
